import { Team } from '../models';
import { TeamRepository } from '../repositories';
import { ModerateContentUseCase } from './ModerateContentUseCase';

export class UpdateTeamUseCase {
  constructor(
    private teamRepository: TeamRepository,
    private moderateContent: ModerateContentUseCase,
  ) {}

  async execute(
    teamId: string,
    updates: Partial<Pick<Team, 'name' | 'description' | 'logoUrl' | 'isPublic'>>,
    userId: string,
  ): Promise<Team> {
    if (updates.name !== undefined) {
      if (!updates.name.trim()) throw new Error('Team name is required');
      await this.moderateContent.execute(updates.name, 'team_name', userId);
    }
    if (updates.description) {
      await this.moderateContent.execute(updates.description, 'team_description', userId);
    }

    return this.teamRepository.update(teamId, updates);
  }
}
